// extracted by mini-css-extract-plugin
export default {"zoomModal":"V4-z","image":"W4-z","button":"X4-z","isOverlayShown":"Y4-z"};